import { booleanAttribute, Component, EventEmitter, Input, Output } from '@angular/core';
import { CalioMatIconComponent } from '@calio-lib/calio-button/calio-mat-icon/calio-mat-icon.component';

/**
 * Calio Icon Component
 *
 * A wrapper component that renders Lucide icons via calio-mat-icon.
 * All icons are now rendered using Lucide (FontAwesome deprecated).
 *
 * @example
 * <app-calio-icon iconType="plus" customClass="my-class" />
 * <app-calio-icon iconType="circle-notch" />
 */
@Component({
  selector: 'app-calio-icon',
  templateUrl: './calio-icon.component.html',
  styleUrls: ['./calio-icon.component.scss'],
  imports: [CalioMatIconComponent],
})
export class CalioIconComponent {
  @Input() iconType: string;
  @Input() customClass: string;
  @Input() title: string;
  @Input() height = '16px';
  @Input() width = '16px';
  @Input({ transform: booleanAttribute }) spin = false;

  @Output() onClick = new EventEmitter<void>();

  get effectiveCustomClass(): string {
    const base = 'icon ' + (this.customClass || '');
    return (this.spin === true) ? `${base} tw-animate-spin` : base;
  }

  /**
   * Get the icon name (handles both string and object formats for backwards compatibility).
   */
  getIconName(): string {
    if (!this.iconType) {return '';}
    return typeof this.iconType === 'string' ? this.iconType : (this.iconType as any)?.iconName || '';
  }

  click(): void {
    this.onClick.emit();
  }
}
